import {
  Companion_getInstanceafwi4dr4nsgt as Companion_getInstance,
  CareProviderRemittances9omflxtwvni as CareProviderRemittance,
  get_entries2njiymqynk3u0 as get_entries,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/money.mjs';
import {
  $serializer_getInstance21thv1dv9fwx4 as $serializer_getInstance,
  CareProvider2qcawrqluyllr as CareProvider,
  ID1m87d1hextx54 as ID,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/domain.mjs';
import { LinkedHashSetSerializer3ncla559t2lx7 as LinkedHashSetSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/CollectionSerializers.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { LocalDateSerializer_getInstance3qg2c8779i3ej as LocalDateSerializer_getInstance } from '../../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalDateSerializers.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  Always_getInstance177eud73uc475 as Always_getInstance,
  And1a3dbpwh0hxmu as And,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Condition.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  arrayOf1akklvh2at202 as arrayOf,
  toString30pk9tzaqopn as toString_0,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual2mm942ha7plg6 as serializerOrContextual } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf18kqeagzkbefr as DataClassPathSelf } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/DataClassPath.mjs';
import {
  get_forDatesipvp1vaghli1 as get_forDates,
  get_start1ib7kl469eh9c as get_start,
  get_endInclusive3dsvnewm08bor as get_endInclusive,
  get_statusn2vo2y7gh1yq as get_status,
  get_voided2jr696tzb1zxm as get_voided,
  get_provider32psqg9zb0w7e as get_provider,
  get_name27z06mu1petol as get_name,
  get__id1301miildb0kq as get__id,
} from '../../../../../../tcg-cares-shared/org/thecommunitygroupinc/cares/ModelFields-372156621.mjs';
import {
  gte1zw995v5ulf70 as gte,
  lte2qmhlnwrclg8p as lte,
  eq353yrgcpovoi1 as eq,
  neqpgb3jcwulnab as neq,
  xDataClassPathInsideSet2a49hafkm1zud as xDataClassPathInsideSet,
} from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/ConditionBuilder.mjs';
import {
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  listOf1jh22dvmctj1r as listOf,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LinearLayouts.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/NativeElement.mjs';
import {
  weight31wqab1913ly4 as weight,
  shownWhen3t7othivfr11 as shownWhen,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { LabeledViewseav57tyecmf as LabeledView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/labels.mjs';
import {
  FieldSemantic_getInstancer1p3l15xmphu as FieldSemantic_getInstance,
  ListSemantic_getInstance2e62q1se6gw64 as ListSemantic_getInstance,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { LocalDateField1854369auhx0q as LocalDateField } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/LocalDateTimeField.commonHtml.mjs';
import { Select2osqjs95yxuh6 as Select } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Select.commonHtml.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { plus310ted5e4i90h as plus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import {
  _Constant___init__impl__v45mub2qfk15kh5l39c as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { remember2m0mx1b5ra75q as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Companion_getInstance23x6zslwzj0st as Companion_getInstance_0 } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { chipMultiselect24u6i0cuozpmn as chipMultiselect } from '../components/multiselect.mjs';
import {
  filterMenu2fz1h01y9a2vu as filterMenu,
  FilterChiptjf5vayz5x4r as FilterChip,
  filterChip1bkihjb9h4931 as filterChip,
} from '../components/filters.mjs';
import { get_currentSessionNotNull30vuua77prq38 as get_currentSessionNotNull } from '../../sdk/currentSession.mjs';
import { SortBuilder36qqny2jtmmgx as SortBuilder } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SortBuilder.mjs';
import { Queryam9ckqg1rxkb as Query } from '../../../../../../service-abstractions-database-shared/com/lightningkite/services/database/Query.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { RenderSize_Abbreviation_getInstance3svlv9et1kjyg as RenderSize_Abbreviation_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.mjs';
import { renderToString2kyj9dlz89tdi as renderToString } from '../../../../../../kiteui-library/com/lightningkite/kiteui/locale/LocalTimeRender.js.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ScrollView.commonHtml.js.mjs';
import { beforeSetup1a13mbd699ddp as beforeSetup } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/ElementWriter.ext.mjs';
import { rowOf3phwx1yo72ntt as rowOf } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/lists.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { modify3w2ijgzr8982m as modify } from '../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { minus27abgkurcn6u0 as minus } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { get_centered31th09q7x90sf as get_centered } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { await1uwe8zvsjq69o as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function RemittanceFilters$Companion$$childSerializers$_anonymous__2bg7ot() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
function RemittanceFilters$Companion$$childSerializers$_anonymous__2bg7ot_0() {
  return new (LinkedHashSetSerializer())($serializer_getInstance());
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        var tmp_1 = lazy(tmp_0, RemittanceFilters$Companion$$childSerializers$_anonymous__2bg7ot);
        var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, null, tmp_1, null, lazy(tmp_2, RemittanceFilters$Companion$$childSerializers$_anonymous__2bg7ot_0)];
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_1() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.views.remittances.RemittanceFilters', this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('forDatesStart', true);
        tmp0_serialDesc.addElement_5pzumi_k$('forDatesEnd', true);
        tmp0_serialDesc.addElement_5pzumi_k$('status', true);
        tmp0_serialDesc.addElement_5pzumi_k$('voided', true);
        tmp0_serialDesc.addElement_5pzumi_k$('providers', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_8v2vkm_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !(value.forDatesStart_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), value.forDatesStart_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.forDatesEnd_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), value.forDatesEnd_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.status_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, tmp2_cached[2].get_value_j01efc_k$(), value.status_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.voided_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, BooleanSerializer_getInstance(), value.voided_1);
        }
        var tmp;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.collections.setOf' call
          var tmp$ret$0 = emptySet();
          tmp = !equals(value.providers_1, tmp$ret$0);
        }
        if (tmp) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, tmp2_cached[4].get_value_j01efc_k$(), value.providers_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_8v2vkm_k$(encoder, value instanceof RemittanceFilters() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp10_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp10_cached[2].get_value_j01efc_k$(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, BooleanSerializer_getInstance(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp10_cached[4].get_value_j01efc_k$(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, LocalDateSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, LocalDateSerializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, tmp10_cached[2].get_value_j01efc_k$(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, BooleanSerializer_getInstance(), tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, tmp10_cached[4].get_value_j01efc_k$(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return RemittanceFilters().new_org_thecommunitygroupinc_cares_views_remittances_RemittanceFilters_52ll7r_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_1().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable(LocalDateSerializer_getInstance()), get_nullable(LocalDateSerializer_getInstance()), get_nullable(tmp0_cached[2].get_value_j01efc_k$()), get_nullable(BooleanSerializer_getInstance()), tmp0_cached[4].get_value_j01efc_k$()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var RemittanceFiltersClass;
function RemittanceFilters() {
  if (RemittanceFiltersClass === VOID) {
    class $ {
      constructor(forDatesStart, forDatesEnd, status, voided, providers) {
        Companion_getInstance_1();
        forDatesStart = forDatesStart === VOID ? null : forDatesStart;
        forDatesEnd = forDatesEnd === VOID ? null : forDatesEnd;
        status = status === VOID ? null : status;
        voided = voided === VOID ? null : voided;
        var tmp;
        if (providers === VOID) {
          // Inline function 'kotlin.collections.setOf' call
          tmp = emptySet();
        } else {
          tmp = providers;
        }
        providers = tmp;
        this.forDatesStart_1 = forDatesStart;
        this.forDatesEnd_1 = forDatesEnd;
        this.status_1 = status;
        this.voided_1 = voided;
        this.providers_1 = providers;
      }
      toCondition_oj74tc_k$() {
        var tmp = Always_getInstance();
        var tmp0_safe_receiver = this.forDatesStart_1;
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_1 = serializerOrContextual(createKType(getKClass(CareProviderRemittance()), arrayOf([]), false));
          var tmp$ret$4 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$4);
          tmp_0 = gte(get_start(get_forDates(it)), tmp0_safe_receiver);
        }
        var tmp_2 = tmp_0;
        var tmp1_safe_receiver = this.forDatesEnd_1;
        var tmp_3;
        if (tmp1_safe_receiver == null) {
          tmp_3 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_4 = serializerOrContextual(createKType(getKClass(CareProviderRemittance()), arrayOf([]), false));
          var tmp$ret$11 = isInterface(tmp_4, KSerializer()) ? tmp_4 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_0 = new (DataClassPathSelf())(tmp$ret$11);
          tmp_3 = lte(get_endInclusive(get_forDates(it_0)), tmp1_safe_receiver);
        }
        var tmp_5 = tmp_3;
        var tmp2_safe_receiver = this.status_1;
        var tmp_6;
        if (tmp2_safe_receiver == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_7 = serializerOrContextual(createKType(getKClass(CareProviderRemittance()), arrayOf([]), false));
          var tmp$ret$18 = isInterface(tmp_7, KSerializer()) ? tmp_7 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_1 = new (DataClassPathSelf())(tmp$ret$18);
          tmp_6 = eq(get_status(it_1), tmp2_safe_receiver);
        }
        var tmp_8 = tmp_6;
        var tmp3_safe_receiver = this.voided_1;
        var tmp_9;
        if (tmp3_safe_receiver == null) {
          tmp_9 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_10;
          if (tmp3_safe_receiver) {
            // Inline function 'com.lightningkite.services.database.condition' call
            // Inline function 'com.lightningkite.services.database.path' call
            // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
            var tmp_11 = serializerOrContextual(createKType(getKClass(CareProviderRemittance()), arrayOf([]), false));
            var tmp$ret$25 = isInterface(tmp_11, KSerializer()) ? tmp_11 : THROW_CCE();
            // Inline function 'kotlin.let' call
            var it_2 = new (DataClassPathSelf())(tmp$ret$25);
            tmp_10 = neq(get_voided(it_2), null);
          } else {
            // Inline function 'com.lightningkite.services.database.condition' call
            // Inline function 'com.lightningkite.services.database.path' call
            // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
            var tmp_12 = serializerOrContextual(createKType(getKClass(CareProviderRemittance()), arrayOf([]), false));
            var tmp$ret$30 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
            // Inline function 'kotlin.let' call
            var it_3 = new (DataClassPathSelf())(tmp$ret$30);
            tmp_10 = eq(get_voided(it_3), null);
          }
          tmp_9 = tmp_10;
        }
        var tmp_13 = tmp_9;
        // Inline function 'kotlin.takeUnless' call
        var this_0 = this.providers_1;
        var tmp_14;
        if (!this_0.isEmpty_y1axqb_k$()) {
          tmp_14 = this_0;
        } else {
          tmp_14 = null;
        }
        var tmp4_safe_receiver = tmp_14;
        var tmp_15;
        if (tmp4_safe_receiver == null) {
          tmp_15 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'com.lightningkite.services.database.condition' call
          // Inline function 'com.lightningkite.services.database.path' call
          // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
          var tmp_16 = serializerOrContextual(createKType(getKClass(CareProviderRemittance()), arrayOf([]), false));
          var tmp$ret$39 = isInterface(tmp_16, KSerializer()) ? tmp_16 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it_4 = new (DataClassPathSelf())(tmp$ret$39);
          tmp_15 = xDataClassPathInsideSet(get_provider(it_4), tmp4_safe_receiver);
        }
        return And().new_com_lightningkite_services_database_Condition_And_6mqlxl_k$(listOfNotNull([tmp, tmp_2, tmp_5, tmp_8, tmp_13, tmp_15]));
      }
      activeCount_htest3_k$() {
        var count = 0;
        if (!(this.forDatesStart_1 == null)) {
          count = count + 1 | 0;
        }
        if (!(this.forDatesEnd_1 == null)) {
          count = count + 1 | 0;
        }
        if (!(this.status_1 == null)) {
          count = count + 1 | 0;
        }
        if (!(this.voided_1 == null)) {
          count = count + 1 | 0;
        }
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.providers_1.isEmpty_y1axqb_k$()) {
          count = count + 1 | 0;
        }
        return count;
      }
      copy_ur8c7u_k$(forDatesStart, forDatesEnd, status, voided, providers) {
        return new (RemittanceFilters())(forDatesStart, forDatesEnd, status, voided, providers);
      }
      copy$default_g2b0n4_k$(forDatesStart, forDatesEnd, status, voided, providers, $super) {
        forDatesStart = forDatesStart === VOID ? this.forDatesStart_1 : forDatesStart;
        forDatesEnd = forDatesEnd === VOID ? this.forDatesEnd_1 : forDatesEnd;
        status = status === VOID ? this.status_1 : status;
        voided = voided === VOID ? this.voided_1 : voided;
        providers = providers === VOID ? this.providers_1 : providers;
        return $super === VOID ? this.copy_ur8c7u_k$(forDatesStart, forDatesEnd, status, voided, providers) : $super.copy_ur8c7u_k$.call(this, forDatesStart, forDatesEnd, status, voided, providers);
      }
      toString() {
        return 'RemittanceFilters(forDatesStart=' + toString_0(this.forDatesStart_1) + ', forDatesEnd=' + toString_0(this.forDatesEnd_1) + ', status=' + toString_0(this.status_1) + ', voided=' + this.voided_1 + ', providers=' + toString(this.providers_1) + ')';
      }
      hashCode() {
        var result = this.forDatesStart_1 == null ? 0 : this.forDatesStart_1.hashCode();
        result = imul(result, 31) + (this.forDatesEnd_1 == null ? 0 : this.forDatesEnd_1.hashCode()) | 0;
        result = imul(result, 31) + (this.status_1 == null ? 0 : this.status_1.hashCode()) | 0;
        result = imul(result, 31) + (this.voided_1 == null ? 0 : getBooleanHashCode(this.voided_1)) | 0;
        result = imul(result, 31) + hashCode(this.providers_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RemittanceFilters()))
          return false;
        if (!equals(this.forDatesStart_1, other.forDatesStart_1))
          return false;
        if (!equals(this.forDatesEnd_1, other.forDatesEnd_1))
          return false;
        if (!equals(this.status_1, other.status_1))
          return false;
        if (!(this.voided_1 == other.voided_1))
          return false;
        if (!equals(this.providers_1, other.providers_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_views_remittances_RemittanceFilters_52ll7r_k$(seen0, forDatesStart, forDatesEnd, status, voided, providers, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.forDatesStart_1 = null;
        else
          $this.forDatesStart_1 = forDatesStart;
        if (0 === (seen0 & 2))
          $this.forDatesEnd_1 = null;
        else
          $this.forDatesEnd_1 = forDatesEnd;
        if (0 === (seen0 & 4))
          $this.status_1 = null;
        else
          $this.status_1 = status;
        if (0 === (seen0 & 8))
          $this.voided_1 = null;
        else
          $this.voided_1 = voided;
        if (0 === (seen0 & 16)) {
          var tmp = $this;
          // Inline function 'kotlin.collections.setOf' call
          tmp.providers_1 = emptySet();
        } else
          $this.providers_1 = providers;
        return $this;
      }
    }
    initMetadataForClass($, 'RemittanceFilters', RemittanceFilters, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    RemittanceFiltersClass = $;
  }
  return RemittanceFiltersClass;
}
function remittanceFilters(_this__u8e3s4, target) {
  var tmp = remittanceFilters$slambda(target);
  return filterMenu(_this__u8e3s4, target, tmp, ($this$filterMenu) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element = new (RowOrCol())($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element);
    $this$filterMenu.willAddChild_hz2iwc_k$(element);
    element.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    var tmp0 = weight(element, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label = 'For dates starting';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_0 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0.get_context_h02k06_k$());
    ensureOutermostElement(element_0);
    tmp0.willAddChild_hz2iwc_k$(element_0);
    element_0.set_content_lzqutq_k$(label);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
    var this_0 = themed(element_0, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_1 = new (LocalDateField())(this_0.get_context_h02k06_k$());
    ensureOutermostElement(element_1);
    this_0.willAddChild_hz2iwc_k$(element_1);
    var tmp = remittanceFilters$lambda$lambda;
    element_1.bind_gesskf_k$(element_1.content_1, target.lens_u4wb4z_k$(tmp, remittanceFilters$lambda$lambda_0));
    element_1.onStartup_vrxh3i_k$();
    this_0.addChild_2qpft2_k$(element_1);
    element_0.onStartup_vrxh3i_k$();
    tmp0.addChild_2qpft2_k$(element_0);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    var tmp0_0 = weight(element, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label_0 = 'For dates ending';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_2 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$(tmp0_0.get_context_h02k06_k$());
    ensureOutermostElement(element_2);
    tmp0_0.willAddChild_hz2iwc_k$(element_2);
    element_2.set_content_lzqutq_k$(label_0);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.localDateField' call
    var this_1 = themed(element_2, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_3 = new (LocalDateField())(this_1.get_context_h02k06_k$());
    ensureOutermostElement(element_3);
    this_1.willAddChild_hz2iwc_k$(element_3);
    var tmp_0 = remittanceFilters$lambda$lambda_1;
    element_3.bind_gesskf_k$(element_3.content_1, target.lens_u4wb4z_k$(tmp_0, remittanceFilters$lambda$lambda_2));
    element_3.onStartup_vrxh3i_k$();
    this_1.addChild_2qpft2_k$(element_3);
    element_2.onStartup_vrxh3i_k$();
    tmp0_0.addChild_2qpft2_k$(element_2);
    element.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_4 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_4);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_4);
    element_4.set_content_lzqutq_k$('Status');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_2 = themed(element_4, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_5 = new (RowOrCol())(this_2.get_context_h02k06_k$());
    ensureOutermostElement(element_5);
    this_2.willAddChild_hz2iwc_k$(element_5);
    element_5.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.select' call
    var this_3 = weight(element_5, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_6 = new (Select())(this_3.get_context_h02k06_k$());
    ensureOutermostElement(element_6);
    this_3.willAddChild_hz2iwc_k$(element_6);
    var tmp_1 = remittanceFilters$lambda$lambda_3;
    var tmp_2 = target.lens_u4wb4z_k$(tmp_1, remittanceFilters$lambda$lambda_4);
    var tmp_3 = _Constant___init__impl__v45mub(plus(listOf_0(null), get_entries()));
    element_6.bind_64a41i_k$(tmp_2, new (Constant())(tmp_3), remittanceFilters$lambda$lambda_5);
    element_6.onStartup_vrxh3i_k$();
    this_3.addChild_2qpft2_k$(element_6);
    element_5.onStartup_vrxh3i_k$();
    this_2.addChild_2qpft2_k$(element_5);
    element_4.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_4);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_7 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_7);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_7);
    element_7.set_content_lzqutq_k$('Voided');
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_4 = themed(element_7, FieldSemantic_getInstance());
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_8 = new (RowOrCol())(this_4.get_context_h02k06_k$());
    ensureOutermostElement(element_8);
    this_4.willAddChild_hz2iwc_k$(element_8);
    element_8.set_vertical_nuap32_k$(false);
    // Inline function 'com.lightningkite.kiteui.views.expanding' call
    // Inline function 'com.lightningkite.kiteui.views.direct.select' call
    var this_5 = weight(element_8, 1.0);
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_9 = new (Select())(this_5.get_context_h02k06_k$());
    ensureOutermostElement(element_9);
    this_5.willAddChild_hz2iwc_k$(element_9);
    var tmp_4 = remittanceFilters$lambda$lambda_6;
    var tmp_5 = target.lens_u4wb4z_k$(tmp_4, remittanceFilters$lambda$lambda_7);
    var tmp_6 = _Constant___init__impl__v45mub(listOf([null, false, true]));
    element_9.bind_64a41i_k$(tmp_5, new (Constant())(tmp_6), remittanceFilters$lambda$lambda_8);
    element_9.onStartup_vrxh3i_k$();
    this_5.addChild_2qpft2_k$(element_9);
    element_8.onStartup_vrxh3i_k$();
    this_4.addChild_2qpft2_k$(element_8);
    element_7.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_7);
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    var label_1 = 'Care provider';
    // Inline function 'com.lightningkite.kiteui.views.l2.label' call
    // Inline function 'com.lightningkite.kiteui.views.write' call
    var element_10 = LabeledView().new_com_lightningkite_kiteui_views_l2_LabeledView_y9e4ty_k$($this$filterMenu.get_context_h02k06_k$());
    ensureOutermostElement(element_10);
    $this$filterMenu.willAddChild_hz2iwc_k$(element_10);
    element_10.set_content_lzqutq_k$(label_1);
    // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
    var tmp_7 = themed(element_10, FieldSemantic_getInstance());
    var tmp_8 = remittanceFilters$lambda$lambda_9;
    var tmp_9 = target.lens_u4wb4z_k$(tmp_8, remittanceFilters$lambda$lambda_10);
    var tmp_10 = remember(VOID, VOID, VOID, VOID, remittanceFilters$lambda$lambda_11);
    chipMultiselect(tmp_7, tmp_9, tmp_10, remittanceFilters$lambda$lambda_12, 'Showing all', Companion_getInstance_0().filterList_1);
    element_10.onStartup_vrxh3i_k$();
    $this$filterMenu.addChild_2qpft2_k$(element_10);
    return Unit_instance;
  });
}
function remittanceFilterChips(_this__u8e3s4, filter) {
  var providerDisplays = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    var tmp = $this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$();
    // Inline function 'com.lightningkite.services.database.sort' call
    // Inline function 'kotlin.apply' call
    var this_0 = new (SortBuilder())();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_0 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
    var tmp$ret$4 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
    var it = new (DataClassPathSelf())(tmp$ret$4);
    this_0.ascending_ijynum_k$(get_name(it));
    // Inline function 'com.lightningkite.services.database.Query' call
    var orderBy = this_0.build_1k0s4u_k$();
    // Inline function 'com.lightningkite.services.database.path' call
    // Inline function 'com.lightningkite.services.database.serializerOrContextual' call
    var tmp_1 = serializerOrContextual(createKType(getKClass(CareProvider()), arrayOf([]), false));
    var tmp$ret$8 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
    var it_0 = new (DataClassPathSelf())(tmp$ret$8);
    var tmp$ret$9 = xDataClassPathInsideSet(get__id(it_0), $this$remember.invoke_r7m7el_k$(filter).providers_1);
    var tmp$ret$6 = new (Query())(tmp$ret$9, orderBy, 0, 100);
    return $this$remember.invoke_r7m7el_k$(tmp.query_so6xq1_k$(tmp$ret$6));
  });
  var chips = remember(VOID, VOID, VOID, VOID, ($this$remember) => {
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var tmp0_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).forDatesStart_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp = 'For dates starting: ' + renderToString(tmp0_safe_receiver, RenderSize_Abbreviation_getInstance());
      this_0.add_utx5q5_k$(new (FilterChip())(tmp0_safe_receiver, tmp, remittanceFilterChips$lambda$slambda(filter)));
    }
    var tmp1_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).forDatesEnd_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = 'For dates ending: ' + renderToString(tmp1_safe_receiver, RenderSize_Abbreviation_getInstance());
      this_0.add_utx5q5_k$(new (FilterChip())(tmp1_safe_receiver, tmp_0, remittanceFilterChips$lambda$slambda_0(filter)));
    }
    var tmp2_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).status_1;
    if (tmp2_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_0.add_utx5q5_k$(new (FilterChip())(tmp2_safe_receiver, tmp2_safe_receiver.displayName_1, remittanceFilterChips$lambda$slambda_1(filter)));
    }
    var tmp3_safe_receiver = $this$remember.invoke_r7m7el_k$(filter).voided_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_1 = tmp3_safe_receiver ? 'Voided' : 'Not voided';
      this_0.add_utx5q5_k$(new (FilterChip())(tmp3_safe_receiver, tmp_1, remittanceFilterChips$lambda$slambda_2(filter)));
    }
    // Inline function 'kotlin.collections.mapTo' call
    var _iterator__ex2g4s = $this$remember.invoke_r7m7el_k$(providerDisplays).iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var item = _iterator__ex2g4s.next_20eer_k$();
      var tmp$ret$23 = new (FilterChip())(new (ID())(item._id_1), item.name_1, remittanceFilterChips$lambda$slambda_3(filter, item));
      this_0.add_utx5q5_k$(tmp$ret$23);
    }
    return this_0.build_nmwvly_k$();
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.scrollingHorizontally' call
  // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
  var this_0 = themed(shownWhen(_this__u8e3s4, VOID, VOID, ($this$shownWhen) => {
    // Inline function 'kotlin.collections.isNotEmpty' call
    return !$this$shownWhen.invoke_r7m7el_k$(chips).isEmpty_y1axqb_k$();
  }), ListSemantic_getInstance());
  var vertical = false;
  var horizontal = true;
  var tmp = beforeSetup(this_0, ($this$beforeSetup) => {
    (new (ScrollingBehaviorImpl())($this$beforeSetup, horizontal, vertical)).set_showScrollBars_vutwwi_k$(false);
    return Unit_instance;
  });
  var tmp_0 = remittanceFilterChips$lambda;
  var tmp_1 = remittanceFilterChips$lambda_0;
  rowOf(tmp, chips, tmp_0, VOID, tmp_1, remittanceFilterChips$lambda_1);
}
function remittanceFilters$slambda($target) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    yield* $target.set_revjhg_k$(new (RemittanceFilters())(), $completion);
    return Unit_instance;
  }), 0);
}
function remittanceFilters$lambda$lambda(it) {
  return it.forDatesStart_1;
}
function remittanceFilters$lambda$lambda_0(old, new_0) {
  return old.copy$default_g2b0n4_k$(new_0);
}
function remittanceFilters$lambda$lambda_1(it) {
  return it.forDatesEnd_1;
}
function remittanceFilters$lambda$lambda_2(old, new_0) {
  return old.copy$default_g2b0n4_k$(VOID, new_0);
}
function remittanceFilters$lambda$lambda_3(it) {
  return it.status_1;
}
function remittanceFilters$lambda$lambda_4(old, new_0) {
  return old.copy$default_g2b0n4_k$(VOID, VOID, new_0);
}
function remittanceFilters$lambda$lambda_5(it) {
  var tmp1_elvis_lhs = it == null ? null : it.displayName_1;
  return tmp1_elvis_lhs == null ? 'All' : tmp1_elvis_lhs;
}
function remittanceFilters$lambda$lambda_6(it) {
  return it.voided_1;
}
function remittanceFilters$lambda$lambda_7(old, new_0) {
  return old.copy$default_g2b0n4_k$(VOID, VOID, VOID, new_0);
}
function remittanceFilters$lambda$lambda_8(it) {
  if (it == null)
    return 'All';
  return it ? 'Voided' : 'Not voided';
}
function remittanceFilters$lambda$lambda_9(it) {
  return it.providers_1;
}
function remittanceFilters$lambda$lambda_10(old, it) {
  return old.copy$default_g2b0n4_k$(VOID, VOID, VOID, VOID, it);
}
function remittanceFilters$lambda$lambda_11($this$remember) {
  return $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(get_currentSessionNotNull()).get_careProviders_b5tc2w_k$().query_so6xq1_k$(new (Query())(Always_getInstance(), VOID, VOID, 2147483647)));
}
function remittanceFilters$lambda$lambda_12(it) {
  return it.name_1;
}
function remittanceFilterChips$lambda$slambda$slambda() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_g2b0n4_k$(null);
  }), 1);
}
function remittanceFilterChips$lambda$slambda($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, remittanceFilterChips$lambda$slambda$slambda(), $completion);
    return Unit_instance;
  }), 1);
}
function remittanceFilterChips$lambda$slambda$slambda_0() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_g2b0n4_k$(VOID, null);
  }), 1);
}
function remittanceFilterChips$lambda$slambda_0($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, remittanceFilterChips$lambda$slambda$slambda_0(), $completion);
    return Unit_instance;
  }), 1);
}
function remittanceFilterChips$lambda$slambda$slambda_1() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_g2b0n4_k$(VOID, VOID, null);
  }), 1);
}
function remittanceFilterChips$lambda$slambda_1($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, remittanceFilterChips$lambda$slambda$slambda_1(), $completion);
    return Unit_instance;
  }), 1);
}
function remittanceFilterChips$lambda$slambda$slambda_2() {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_g2b0n4_k$(VOID, VOID, VOID, null);
  }), 1);
}
function remittanceFilterChips$lambda$slambda_2($filter) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, remittanceFilterChips$lambda$slambda$slambda_2(), $completion);
    return Unit_instance;
  }), 1);
}
function remittanceFilterChips$lambda$slambda$slambda_3($provider) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    return it.copy$default_g2b0n4_k$(VOID, VOID, VOID, VOID, minus(it.providers_1, new (ID())($provider._id_1)));
  }), 1);
}
function remittanceFilterChips$lambda$slambda_3($filter, $provider) {
  return constructCallableReference((it, $completion) => orPromise($completion, function *($completion) {
    yield* modify($filter, remittanceFilterChips$lambda$slambda$slambda_3($provider), $completion);
    return Unit_instance;
  }), 1);
}
function remittanceFilterChips$lambda(it) {
  return to(it.value_1, it.label_1);
}
function remittanceFilterChips$lambda_0($this$rowOf) {
  return get_centered($this$rowOf);
}
function remittanceFilterChips$lambda_1($this$rowOf, item) {
  var tmp = lens(item, remittanceFilterChips$lambda$lambda);
  filterChip($this$rowOf, tmp, VOID, remittanceFilterChips$lambda$slambda_4(item));
  return Unit_instance;
}
function remittanceFilterChips$lambda$lambda(it) {
  return it.label_1;
}
function remittanceFilterChips$lambda$slambda_4($item) {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $item;
    yield* (yield* await_0(this_0, $completion)).remove_94srgz_k$($completion);
    return Unit_instance;
  }), 0);
}
//region block: exports
export {
  RemittanceFilters as RemittanceFilters1eq211s3cpfnh,
  remittanceFilterChips as remittanceFilterChips1jkzs2o9cqqi5,
  remittanceFilters as remittanceFiltersr0yrgmhainah,
};
//endregion

//# sourceMappingURL=RemittanceFilters.mjs.map
